import React, {
  FC
} from 'react';

import {
  ArqLoginImage
} from 'src/shared/icons';

import * as Style from './LoginLeftSide.styles';

interface LoginLeftSideProps {
  coverPhotoUrl?: string | null;
}

export const LoginLeftSide: FC<LoginLeftSideProps> = ({
  coverPhotoUrl
}) => {
  return (
    <Style.MainContainer>
      {coverPhotoUrl ? (
        <Style.ChartImageContainer $backgroundImage={coverPhotoUrl} />
      ) : (
        <Style.ChartImageContainer>
          <Style.ImageContainer
            src={ArqLoginImage}
            alt="arq decisions logo"
          />
        </Style.ChartImageContainer>
      )}
    </Style.MainContainer>
  );
};
